import axios from './axios';
import utils from '../lib/utils';

export default {
  axios,
  // 获取地址详情
  getUserAddressById(params) {
    return axios.get(`/onlineDrug/getPatientByOpenId?${utils.exchangeParams(params)}`);
  },
  getToken(params) {
    return axios.post('/link/getTokenByLink', params);
  },
};
